import React from 'react';
import { Button, Skeleton, SkeletonItem, makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  resultWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: '36px',
    gap: '24px',
  },
  cardWrapper: {
    backgroundColor: '#fff',
    width: '358px',
    height: '360px',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '12px',
  },
  headerTitle: {
    width: '183px',
  },
  headerSubTitle: {
    width: '100px',
    marginTop: '12px',
  },
  previewRow: {
    width: '100%',
    height: '209px',
  },
  previewItem: {
    height: '100%',
  },
  footerRow: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px',
  },
  footerDescription: {
    width: '100%',
  },
  footerButton: {
    marginTop: '12px',
    width: 'fit-content',
  },
});

const AdResultShimmer = () => {
  const classes = useStyles();
  return (
    <div className={classes.cardWrapper}>
      <Skeleton animation="wave">
        <div className={classes.headerRow}>
          <SkeletonItem shape="circle" size={36} />
          <div className={classes.headerText}>
            <SkeletonItem className={classes.headerTitle} shape="square" size={12} />
            <SkeletonItem className={classes.headerSubTitle} shape="square" size={12} />
          </div>
        </div>
        <div className={classes.previewRow}>
          <SkeletonItem className={classes.previewItem} shape="square" size={209} />
        </div>
        <div className={classes.footerRow}>
          <SkeletonItem className={classes.footerDescription} shape="square" size={12} />
          <Button className={classes.footerButton} appearance="primary" disabled disabledFocusable>
            View ad details
          </Button>
        </div>
      </Skeleton>
    </div>
  );
};

const AdResultLoadingEffectComponent = () => {
  const classes = useStyles();
  const adResultShimmers = [...Array(6)].map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <AdResultShimmer key={index} />
  ));

  return (
    <div className={classes.resultWrapper}>
      { adResultShimmers }
    </div>
  );
};

export const AdResultLoadingEffect = AdResultLoadingEffectComponent;
